//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

export const fetchWrapper = async (url: string, options: RequestInit) => {
  const response = await fetch(url, options);

  if (response.status >= 400) {
    let userMessage = 'An unexpected error occurred. Please try again later.';
    try {
      const errorBody = await response.json();
      // Sanitize both detail and message fields to prevent SQL/schema
      // information leaking to the client (NEXUS00006084).
      const sqlLeakPattern =
        /\b(sql|jdbc|hibernate|stacktrace)\b|\.schema\.|column\s*['"`]|select\s+\*|select\s+\w+\s+from|insert\s+into|update\s+\w+\s+set|delete\s+from|org\.\w+\.exception/i;
      const safeDetail =
        errorBody.detail &&
        typeof errorBody.detail === 'string' &&
        !sqlLeakPattern.test(errorBody.detail);
      const safeMessage =
        errorBody.message &&
        typeof errorBody.message === 'string' &&
        !sqlLeakPattern.test(errorBody.message);
      if (safeDetail) {
        userMessage = errorBody.detail;
      } else if (safeMessage) {
        userMessage = errorBody.message;
      }
    } catch {
      // Response body was not valid JSON — use generic message
    }
    throw new Error(`Error ${response.status}: ${userMessage}`);
  }

  return response.json();
};
